import request from '@/utils/request';

/**
 *  订阅套餐接口
 */
export const getPaypalInfo = (data: { planId: string }) => {
  return request.post<{ approveUrl: string; subscriptionId: string }>(
    '/api/plan/subscription/paypal',
    data,
  );
};

export interface SubscriptionPaypalInfo {
  approveUrl: string;
  subscriptionId: string;
  bizType?: 1 | 2; // 1：套餐  2：资源
}

/**
 *  订阅套餐接口
 */
export const subscriptionPaypal = (data: {
  bizId: number;
  couponId?: string;
  country: string;
  address?: string;
  zipCode?: string;
  bizType: 1 | 2; // 1套餐 2流量
}) => {
  return request.post<SubscriptionPaypalInfo>('/api/plan/subscription/paypal', data);
};

export enum PlanSubPayStatusEnum {
  Wait = 1,
  Success = 2,
  Fail = 3,
  Cancel = 4,
}

/**
 *  获取订阅单信息
 */
export const planSubscription = (data: { subscriptionId: string }) => {
  return request.get<{ planSubPayStatus: PlanSubPayStatusEnum }>('/api/plan/subscription', data);
};

export interface ResourceItem {
  /** 当前套餐的总流量 */
  data: number;
  /** 当前套餐的总存储 */
  storage: number;
  /** 当前套餐的已用流量 */
  usedData: number;
  /** 当前套餐的已用存储 */
  usedStorage: number;
}

export interface PlanItem {
  name: string;
  expireDate: string;
  planId: number;
  /** 套餐类型 1 正常套餐 2 无限期使用套餐（试用套餐结束后套餐） 3 注册十四天试用套餐 */
  planType: 1 | 2 | 3;
  data: number; // 原bandwidth，套餐包含流量大小
  storage: number; // 套餐包含内存大小
}

export interface PlanDetail {
  packageId: number;
  name: string;
  /** 套餐支付类型 1 按天 2按月 3 按年 */
  type: 1 | 2 | 3;
  discountPrice: number;
  description: string;
  expireDate: string;
  planId: number;
  highlight: string;
  /** 套餐类型 1 标准套餐 2 无限期使用套餐 3 注册赠送套餐 */
  planType: 1 | 2 | 3;
  subtitle: string;
  originPrice: number;
  storage: number;
  data: number;
  [propName: string]: any;
}

export interface IInvitationCode {
  code: string;
  planId: number;
  dayNum: number;
}

/**
 *  套餐列表
 */
export const getPlanList = () => {
  return request.get<PlanDetail[]>('/api/plan/package-list');
};

/**
 * 获取当前正在使用的套餐
 */
export const getCurrentPlan = () => {
  return request.get<PlanItem>('/api/plan/current-plan');
};

/**
 * 获取用户资源
 */
export const getCurrentResource = () => {
  return request.get<ResourceItem>('/api/plan/current-resource');
};

export interface RecordItem {
  subscriptionId: string;
  name: string;
  price: number;
  actuallyPaid: number;
  // 支付状态: 1待支付；2支付成功；3支付失败；4支付取消
  payStatus: 1 | 2 | 3 | 4;
  expireDate: string;
  createdAt: string;
  type: number;
}

/**
 * 获取历史订购列表
 */
export const getPurchaseRecordsList = (data: { startTime: number }) => {
  return request.get<RecordItem[]>('/api/plan/purchase-records', data);
};

export interface PlanCalculateParam {
  frequencyType: 1 | 2 | 4; // 推流频率 1 Monthly(默认)、2 Weekly 4 Daily
  frequency: number | undefined;
  minute: number | undefined;
  person: number | undefined;
  bitrate: 350 | 800 | 1000 | 1500 | 1800 | 2500 | 3500 | 4500 | 7000;
}

/**
 * 计算器
 */
export const planCalculate = (data: PlanCalculateParam) => {
  return request.get<PlanItem>('/api/plan/calculate', data);
};

/**
 * 套餐描述
 */
export interface IFeatureDetail {
  auth: boolean;
  number: number;
  planId: number;
}
export interface IFeatureItem {
  data: IFeatureDetail[];
  featureId: number;
  moduleName: string;
  name: string;
  tips: string;
}
export const getFeatures = () => {
  return request.get<Array<IFeatureItem>>('/api/plan/list-features');
};

/**
 * 折扣优惠
 */
export enum PromoType {
  FIX_PRICE = 1,
  PERCENTAGE_PRICE = 2,
}
export interface IPromoDetail {
  discountAmount: number;
  promotionCodeId: string;
  sceneType: PromoType;
}
export const checkPromotionCode = (data: { code: string }) => {
  return request.post<IPromoDetail>(`/api/plan/check-promotion-code/${data.code}`);
};
